import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import { Company, CreateCompany } from '@recruitee/http-types';

@Injectable({ providedIn: 'root' })
export class CompanyHttpService {
  constructor(protected httpApi: HttpApiService) {}

  public update(body: Partial<Company>): Observable<Company> {
    return this.httpApi.patch(`/company`, null, {
      company: body,
    });
  }

  public create(body: CreateCompany, skipCompany: boolean = false): Observable<Company> {
    const { fillWithSampleData, ...company } = body;
    return this.httpApi.post(
      `/companies`,
      null,
      {
        company,
        fillWithSampleData,
      },
      { skipCompany },
    );
  }

  public leave({ id }: { id: number }): Observable<Company> {
    return this.httpApi.patch(`/companies/${id}/leave`);
  }
}
